// General
import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './SignupModal.css';
import c from '../../components/LoginModal/LoginModal.css';
import bt from '../../components/commonStyle.css';
import {
  Button,
  FormGroup,
  Modal,
  Image
} from 'react-bootstrap';

// Redux
import { connect, useDispatch, useSelector } from 'react-redux';
import { closeSignupModal, openLoginModal } from '../../actions/modalActions';

// Components
import SocialLogin from '../SocialLogin';
import RegisterForm from '../RegisterForm';
import Link from '../Link';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../locale/messages';
import imageOne from '/public/SiteIcons/mailLight.png';

const SignupModal = () => {
  const signupModal = useSelector(state => state.modalStatus.isSignupModalOpen);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const dispatch = useDispatch();
  const openForm = () => {
    setIsFormOpen(true);
  };

  const renderButtons = () => {
    return (
      <>
        <FormGroup className={s.formGroup}>
          <Button className={cx(bt.btnPrimary, bt.btnBig)} onClick={() => openForm()} block>
            <Image src={imageOne} className={cx(s.iconPosition, 'iconPositionRtl')} responsive /><FormattedMessage {...messages.signupWithEmail} />
          </Button>
          <h4 className={c.lineThrough}>
            <span className={c.linetext}><FormattedMessage {...messages.or} /></span>
          </h4>
          <SocialLogin />
        </FormGroup>
      </>
    );
  };

  const renderForm = () => {
    return (
      <>
        <RegisterForm />
        <h4 className={c.lineThrough}>
          <span className={c.linetext}><FormattedMessage {...messages.or} /></span>
        </h4>
        <SocialLogin />
      </>
    );
  }

  return (
    
    <Modal show={signupModal} animation={false} onHide={() => dispatch(closeSignupModal())}
      dialogClassName={'loginModal'} >
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage {...messages.signup} /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={c.root}>
          <div className={c.container}>
            <RegisterForm />
            <h4 className={c.lineThrough}>
              <span className={c.linetext}><FormattedMessage {...messages.or} /></span>
            </h4>
            <SocialLogin />
            <p className={c.linkText}>
              <FormattedMessage {...messages.alreadyHaveAccount} />
              <Link className={c.modalCaptionLink} onClick={() => dispatch(openLoginModal())}>
                <FormattedMessage {...messages.logInHere} />
              </Link>
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

SignupModal.propTypes = {
  closeSignupModal: PropTypes.func,
  signupModal: PropTypes.bool,
  openLoginModal: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default withStyles(s, bt, c)(SignupModal);